export function getObject (theObject, propName, propValue) {
  var result = null
  if (theObject instanceof Array) {
    for (var i = 0; i < theObject.length; i++) {
      result = getObject(theObject[i], propName, propValue)
      if (result) {
        break
      }
    }
  } else {
    for (var prop in theObject) {
      // console.log(prop + ': ' + theObject[prop])
      if (prop === propName) {
        if (theObject[prop] === propValue) {
          return theObject
        }
      }
      if (theObject[prop] instanceof Object || theObject[prop] instanceof Array) {
        result = getObject(theObject[prop], propName, propValue)
        if (result) {
          break
        }
      }
    }
  }
  return result
}
